import { GraphQLFormattedError } from 'graphql';
import _some from 'lodash/some';

let isRedirecting = false;

export function hasAuthenticationError(
  graphQLErrors: readonly GraphQLFormattedError[] | undefined,
): boolean {
  return _some(
    graphQLErrors,
    ({ extensions }) => extensions?.code === 'AUTHENTICATION_ERROR',
  );
}

export function handleAuthenticationError(redirectUrl: string): void {
  if (isRedirecting) return;
  isRedirecting = true;
  localStorage.clear();
  window.location.href = redirectUrl;
}

// Exported for testing only
export function resetRedirectingState(): void {
  isRedirecting = false;
}
